import {
  manageListingsFilterSearchParams,
  resolveManageListingsFilters,
} from '../containers/ManageListingsPage/ManageListingsPage.filters';
import { parse } from './urlHelpers';
import { PROFILE_TAB_LISTINGS } from './profilePageTabs';

const BUYER_LISTINGS_PARAM_KEYS = ['category', 'subcategory', 'sort'];

/**
 * Canonical search string for the owner's profile listings tab.
 * Buyer filters are dropped. Hide filters follow the same URL-over-saved-preference
 * rules as /listings.
 *
 * @param {string} search
 * @param {Object|null|undefined} currentUser
 * @returns {string} e.g. `?tab=listings&hideClosed=true&page=2`
 */
export const ownProfileManageListingsSearch = (search, currentUser) => {
  const queryParams = parse(search);
  const { hideClosed, hideDrafts } = resolveManageListingsFilters({ queryParams, currentUser });
  const page = typeof queryParams.page === 'number' ? queryParams.page : undefined;
  const filters = manageListingsFilterSearchParams({ hideClosed, hideDrafts, page });
  const params = new URLSearchParams();
  params.set('tab', PROFILE_TAB_LISTINGS);
  if (filters.hideClosed) {
    params.set('hideClosed', 'true');
  }
  if (filters.hideDrafts) {
    params.set('hideDrafts', 'true');
  }
  if (filters.page) {
    params.set('page', String(filters.page));
  }
  return `?${params.toString()}`;
};

/**
 * Query-string compare that ignores parameter order.
 * Route helpers sort keys; this helper writes `tab` first.
 *
 * @param {string|null|undefined} search
 * @returns {string}
 */
export const normalizeProfileSearch = search => {
  const raw = !search || typeof search !== 'string' ? '' : search.replace(/^\?/, '');
  const params = new URLSearchParams(raw);
  const sorted = [...params.entries()].sort(([a], [b]) => a.localeCompare(b));
  const next = new URLSearchParams(sorted);
  const qs = next.toString();
  return qs ? `?${qs}` : '';
};

/**
 * @param {string|null|undefined} search
 * @returns {boolean}
 */
export const searchHasBuyerListingsParams = search => {
  if (!search || typeof search !== 'string') {
    return false;
  }
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  return BUYER_LISTINGS_PARAM_KEYS.some(key => {
    const value = params.get(key);
    return value != null && value !== '';
  });
};
